import React from 'react'
import { useNativeAuth, UseNativeAuthReturn } from '../auth/useNativeAuth'

const AuthContext = React.createContext<UseNativeAuthReturn | undefined>(undefined)

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useNativeAuth()
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const ctx = React.useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
